export type Style = 'Podcast' | 'Youtube' | 'Training';

export interface StyleDetail {
  style: Style;
}

export const sentences: StyleDetail[] = [
  {
    style: 'Podcast',
  },
  { style: 'Youtube' },
  { style: 'Training' },
];
